import React from "react"
import { useConfirmDialog } from "../../components/ConfirmDialog"
import { useCalendarEventMutations } from "./use-calendar-event-mutations"
import { useTranslation } from "react-i18next"

export const useDeleteEvent = () => {
  const translations = useTranslations()
  const { deleteEvent } = useCalendarEventMutations()
  const [status, setStatus] = React.useState("idle")

  const onConfirmDeleteEvent = async (eventId: string) => {
    const deleted = await deleteEvent(eventId)
    if (deleted) return setStatus(`deleted:${eventId}`)
    return setStatus(`error:${eventId}`)
  }

  const onCancelDeleteEvent = (eventId: string) => setStatus(`cancelled:${eventId}`)
  const resetStatus = () => setStatus("idle")

  const { confirm: deleteEventWithConfirmation } = useConfirmDialog({
    onConfirm: onConfirmDeleteEvent,
    onCancel: onCancelDeleteEvent,
    primaryActionButtonLabel: translations.deleteEventDialog.primaryActionButtonLabel,
    secondaryActionButtonLabel: translations.deleteEventDialog.secondaryActionButtonLabel,
    title: translations.deleteEventDialog.title,
    text: translations.deleteEventDialog.text,
  })

  return {
    deleteEvent: deleteEventWithConfirmation,
    status,
    resetStatus,
  }
}

const useTranslations = (defaults = defaultTranslations): Translations => {
  const { t: eventTranslations } = useTranslation("calendarEvent")
  const { t: translations } = useTranslation("translation")

  const deleteEventDialog = {
    title: eventTranslations("deleteEventDialog.title") || defaults.deleteEventDialog.title,
    text: eventTranslations("deleteEventDialog.text") || defaults.deleteEventDialog.text,
    primaryActionButtonLabel:
      eventTranslations("calendarEventDetails.deleteButtonLabel") ||
      defaults.deleteEventDialog.primaryActionButtonLabel,
    secondaryActionButtonLabel: translations("cancel") || defaults.deleteEventDialog.secondaryActionButtonLabel,
  }

  return {
    deleteEventDialog,
  }
}

const defaultTranslations = {
  deleteEventDialog: {
    title: "Do you want to delete this event?",
    text: "This action will erase the event from database and it can not be recovered.",
    primaryActionButtonLabel: "Delete event",
    secondaryActionButtonLabel: "Cancel",
  },
}

type Translations = typeof defaultTranslations
